import styled from "styled-components";

export const Container = styled.div`
  position: sticky;
  top: 0;
  z-index: 25;
  background: #fff;
  .header-app {
    > div {
      min-height: 56px;
    }
  }
  .weather-alert-btn {
    border: 1px solid #82dbcf;
    border-radius: 30px;
    height: 30px;
    color: #040707;
    font-size: 14px;
    font-family: "latoregular";
    text-transform: initial;
    padding: 5px 15px;
  }
  .navbar {
    height: 100vh;
  }
  .logo {
    max-width: 82px;
    /* margin-right: 12px; */
  }
  .sitelink {
    cursor: pointer;
  }
`;

export const HelpContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
  color: var(--text-primary);
  font-family: "latoregular";
`;

export const SiteBoxContainer = styled.div`
  position: absolute;
  top: 57px;
  z-index: 99;
  width: 350px;
  right: 42px;
  background: #fff;
  box-shadow: 0px 10px 25px rgb(0 0 0 / 10%);
  border-radius: 6px;
  /* max-height: 350px;
  overflow-y: auto; */
`;

export const SearchWrapper = styled.div`
  position: relative;
  display: inline-flex;
  width:90%;
  input {
    width: 100%;
    height: 31px;
    border: 1px solid #e1e1e1;
    border-radius: 5px;
    padding: 0 37px 0 10px;
  }
  .search-icon {
    position: absolute;
    right: 10px;
    top: 8px;
  }
  .close-icon{
    position: absolute;
    right: -34px;
  }
    button {
    border: 1px solid #e1e1e1;
    border-radius: 5px;
    background-color: white
    }
`;

export const SearchSection = styled.div`
  padding: 10px 7px 10px 11px;
  display: flex;
  align-items: center;
  gap: 6px;
  border-bottom: 1px solid #e1e1e1;
`;

export const ResentSite = styled.ul`
  padding: 10px 20px 15px;
  border-bottom: 1px solid #e1e1e1;
  font-family: "latosemibold";
  li {
    padding: 2px 0;
  }
`;

export const AllSite = styled.ul`
  padding: 10px 20px 15px;
  max-height: 210px;
    overflow-y: auto;
  li {
    padding: 2px 0;
  }
`;

export const AllSiteBtn = styled.button`
  height: 31px;
  border: 1px solid var(--border-color);
  border-radius: 10px;
  font-size: 12px;
  line-height: 150.5%;
  background-color: transparent;
  color: var(--text-primary);
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  &.pointer-event-none {
    pointer-events: none;
  }
  &.disabled {
    opacity: 0.6;
    cursor: default;
    /* pointer-events: none; */
  }
  &.active {
    background: #bc9b6a;
    color: #fff;
    border-color: transparent;
  }
  /* cursor: pointer;
  font-family: "latoregular"; */
`;

export const ChangePasswordPopup = styled.div`
  .header {
    background: #6b5c4b;
    border-radius: 5px 5px 0px 0px;
    height: 40px;
    font-weight: 700;
    font-size: 14px;
    line-height: 150.5%;
    padding: 9px 28px;
    color: #ffffff;
  }
  .form-style {
    padding: 10px 28px 28px;
    > p {
      font-size: 13px;
      line-height: 150.5%;
      margin-bottom: 10px;
    }
    > input {
      background: #ffffff;
      border: 1px solid #cdcfd0;
      border-radius: 6px;
      width: 100%;
      height: 35px;
      margin-bottom: 13px;
      padding: 8px;
    }
    .password-text {
      padding-left: 15px;
      color: red;
      li {
        font-size: 14px;
        margin: 5px 0;
        list-style: disc;
      }
    }
  }
  .action-wrapper {
    display: flex;
    align-items: center;
    gap: 30px;
    justify-content: center;
    margin-top: 20px;
    button {
      min-height: 43px;
      min-width: 111px;
      color: #1d1d1d;
      font-weight: 700;
      font-size: 16px;
      line-height: 150.5%;
      border: 1px solid #636f7c;
      border-radius: 30px;
      background-color: #fff;
    }
    input {
      background: #bc9b6a;
      border-radius: 30px;
      min-height: 43px;
      min-width: 111px;
      color: #fff;
      border: 1px solid #bc9b6a;
      border-radius: 30px;
      font-weight: 700;
      font-size: 16px;
      line-height: 150.5%;
      cursor: pointer;
      :disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }
  }
`;
